// A drum loop's measured swing as React reads it: the manifest's value, or the
// player's once it has decoded a loop that carries none (an uploaded one).

import { useSyncExternalStore } from 'react';
import { drumLoopURL, type DrumLoop } from './drumLoops';
import { measuredLoopSwing, subscribeLoopSwing } from './loopSwing';

/** Undefined while there is no loop or it has not been measured yet. */
export function useLoopSwing(loop: DrumLoop | undefined): number | null | undefined {
  const url = loop ? drumLoopURL(loop) : '';
  const measured = useSyncExternalStore(subscribeLoopSwing, () =>
    url ? measuredLoopSwing(url) : undefined,
  );
  if (!loop) return undefined;
  return loop.swing !== undefined ? loop.swing : measured;
}
